/**
 * <robotryx-richtext> — the story band's "check them out" scroll cue.
 *
 * Replaces an inline jQuery block that did the same job:
 *
 *   $(".down").click(function () {
 *     var nextSectionTop = $(".robotryx_richtext").parent().next().offset().top;
 *     $('html, body').animate({ scrollTop: nextSectionTop }, 1000);
 *   });
 *
 * That worked — jQuery is loaded globally from theme.liquid — but CLAUDE.md
 * bans new jQuery, and `.down` was a document-wide selector bound from inside a
 * section, so two mounts of this section on one page would each bind a handler
 * to BOTH cues. Scoped to the element here, and native smooth scrolling drops
 * the dependency entirely.
 *
 * Target: the next sibling <section> wrapper, i.e. the divider below this band —
 * the same node the jQuery version resolved via .parent().next().
 */
class RobotryxRichtext extends HTMLElement {
  connectedCallback() {
    this.cue = this.querySelector('[data-scroll-cue]');
    if (!this.cue) return;
    this.cue.addEventListener('click', this.scrollToNext.bind(this));
  }

  scrollToNext(event) {
    event.preventDefault();

    // The section wrapper Shopify renders around this element, then its sibling.
    const wrapper = this.closest('.shopify-section') || this.parentElement;
    const target = wrapper && wrapper.nextElementSibling;
    if (!target) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }
}

if (!customElements.get('robotryx-richtext')) {
  customElements.define('robotryx-richtext', RobotryxRichtext);
}
